import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {BuilderPaneBase} from 'common/widgets/cohorts-query-builder/common-components/builder-pane-base/index';
import {FREQUENCY_OPERATOR_LIST} from 'common/widgets/cohorts-query-builder/models/constants';

import template from './index.jade';
import css from './index.styl?inline';

class CohortsBuilderFrequency extends BuilderPaneBase {
  get config() {
    return {
      ...super.config,
      useShadowDom: true,
      css,
      template,
      helpers: {
        ...super.config.helpers,
        FREQUENCY_OPERATOR_LIST,
        getSelectedFrequencyOperator: () => {
          const {stagedCohort, stagedClausePosition} = this.state;
          return stagedCohort.getFrequencyOperator(stagedClausePosition);
        },
        clickedFrequencyOperator: (frequencyOperator) => {
          this.dispatchBubbledEvent(`selected-frequency-operator`, frequencyOperator);
        },
      },
    };
  }
}

export const CohortsBuilderFrequencyEl = defineAndMakeJsxFactory(`cohorts-builder-frequency`, CohortsBuilderFrequency);
